import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import { FC } from 'react';
import { ConfirmationDialogProps } from '../../../utils/DataTypes';

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Confirm Save',
  message = 'Are you sure you want to save the changes?',
  cancelButtonLabel = 'Cancel',
  okButtonLabel = 'Save',
}) => {
  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {cancelButtonLabel}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {okButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
